import {
    Component,
    EventEmitter,
    Injector,
    Output,
    ViewChild,
  } from '@angular/core';
  import { ImpersonationService } from '@app/admin/users/impersonation.service';
  import { AppComponentBase } from '@shared/common/app-component-base';
  import { ModalDirective } from 'ngx-bootstrap/modal';
  
  @Component({
    selector: 'removeStaffFromProjectConfirmModal',
    templateUrl: './remove-staff-from-project-confirm-modal.component.html',
    styleUrls: ['remove-staff-from-project-confirm-modal.component.less'],
  })
  export class RemoveStaffFromProjectConfirmModalComponent extends AppComponentBase {
    @ViewChild('modal', { static: true }) modal: ModalDirective;
  
    options: any;
  
    @Output() removestaffsromproject$: EventEmitter<any> = new EventEmitter<any>();
  
    constructor(
      injector: Injector
    ) {
      super(injector);
    }
  
    show(options: any): void {
      this.options = options;
      this.modal.show();
    }
    close(): void {
      this.modal.hide();
    }
  
    delete(): void {
      this.removestaffsromproject$.emit(this.options);
      this.modal.hide();
    }
  }
  